var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('common-header',{attrs:{"headerInput":_vm.headerInput,"focus":"ETL","mobile":true}}),_c('router-view'),_c('back-to-top',{scopedSlots:_vm._u([{key:"img",fn:function(){return [_c('img',{attrs:{"src":require('../src/assets/footer-down.png')}})]},proxy:true}])}),_c('common-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }